import { Stack } from "@mui/material";
import { PrimaryButton, SecondaryButton } from '@/components';
import { useBoolean } from 'usehooks-ts';
import { ReactElement, useRef } from 'react';
import { useUploadCSVMutation } from '../hooks/use-upload-csv';
import { queryClient } from '@/lib';
import { usersQueryKeys } from '../data';
import { toast } from 'react-toastify';
import { CreateUserDrawer } from './CreateUserDrawer';

export const ManageUserActions = (): ReactElement => {
  const {
    value: shouldShowCreateUserDrawer,
    toggle: toggleCreateUserDrawer,
    setFalse,
  } = useBoolean();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const uploadCsvMutation = useUploadCSVMutation({
    onSuccess: () => {
      toast.success('CSV imported successfully! Users may take a few minutes to appear.');
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: usersQueryKeys.getUsers });
      }, 10000); // 10 second delay
    },
    onError: () => {
      toast.error('Failed to upload CSV. Please try again.');
    },
  });

  const handleImportCSV = () => {
    fileInputRef.current?.click();
  };

  const handleCreateUser = () => {
    toggleCreateUserDrawer();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      uploadCsvMutation.mutate({ file });
    }
    // Reset the input so the same file can be selected again
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  return (
    <Stack direction={"row"} gap={1} alignItems="center" justifyContent="space-between" pb={1}>
      <SecondaryButton
        size='large'
        onClick={handleCreateUser}
        sx={{ textTransform: 'none' }}
      >
        Create User
      </SecondaryButton>
      <PrimaryButton
        size='large'
        onClick={handleImportCSV}
        sx={{ textTransform: 'none' }}
        loading={uploadCsvMutation.isPending}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginRight: 4 }}
        >
          <path
            d="M12 5V19"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M5 12H19"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg> 
        Import CSV
      </PrimaryButton>
      {/* ===== MAKE SURE THIS IS HIDDEN, THIS IS WHERE THE FILE WILL BE STORED ========= */}
      <input
        ref={fileInputRef}
        type="file"
        accept=".csv"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      {/* =============================================================================== */}
      <CreateUserDrawer value={shouldShowCreateUserDrawer} setFalse={setFalse} />
    </Stack>
  );
}